export type { UserEventConfig, UserEventInstance } from './setup';
export { setup } from './setup';
